import { numberToPrettyString } from '@cian/utils';

import {
  ECurrency,
  IPriceForMobileSite,
} from '../../../../../common/repositories/dailyrent/entities/price_for_mobile_site/PriceForMobileSite';

export const currencyToString = (currency: ECurrency) => {
  switch (currency) {
    case ECurrency.Eur:
      return '€';
    case ECurrency.Usd:
      return '$';
    case ECurrency.Rur:
    default:
      return '₽';
  }
};

interface IFormatPriceProps extends Pick<IPriceForMobileSite, 'value' | 'currency'> {}

export const formatPrice = (price: IFormatPriceProps, hasDates: boolean) => {
  const number = numberToPrettyString(price.value);
  const currency = currencyToString(price.currency);

  return hasDates ? `${number} ${currency}/сут.` : `от ${number} ${currency}/сут.`;
};
